import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

export function useDestinationOfferModuleAnalytics(placement) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);
  const { contentBlockId = "", lfmaDetails = [] } = placement?.placementData ?? {};

  useEffect(() => {
    if ((pathname === "/" || pathname.includes("/landing/home-page/")) && lfmaDetails.length) {
      setMktgPageData(
        {
          moduledetaildestinationoffers: getModuleDetails(),
        },
        "landingHomePage"
      );
    }
  }, [pathname, lfmaDetails.length]);

  function getModuleDetails() {
    let contentDetails = null;

    if (lfmaDetails) {
      contentDetails = lfmaDetails
        .map((lfmaDetail) => [contentBlockId, ...Object.values(lfmaDetail)].join(";"))
        .join(",");
    }

    return contentDetails;
  }
}
